export const CHECKOUT_BREAKDOWN = "Checkout breakdown";
export const EXPERIENCE_TOTAL = "Total";
export const TAXES_AND_FEES_INCLUDED = "Price is inclusive of taxes.";
export const PAID_AT_TIME_OF_BOOKING = "Paid at time of booking";
export const FEES_DUE_UPON_ARRIVAL = "Fees due at arrival";
export const MANDATORY_FEES_BELOW =
  "Any fees due at the time of the activity are shown below.";
export const MANDATORY_FEES_TOOLTIP_TEXT =
  "All additional fees are calculated based on the total number of travelers. Fees may vary upon arrival to your activity.";
